<template>
  <BRow class="mb-4">
    <BCol>
      <h1>User Management</h1>
    </BCol>
    <BCol class="text-end">
      <BButton
        variant="primary"
        @click="$emit('create-user')"
      >
        + Create New User
      </BButton>
    </BCol>
  </BRow>
</template>

<script setup lang="ts">
import { BRow, BCol, BButton } from "bootstrap-vue-next";

defineEmits<{
  "create-user": [];
}>();
</script>
